import { Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Form, Link, useSearchParams } from "react-router-dom";

export default function KontaktFormular() {
  const [searchParams] = useSearchParams();

  const [betreff, setBetreff] = useState<string>("");
  const [nachricht, setNachricht] = useState<string>("");

  useEffect(() => {
    setBetreff(searchParams.get("betreff") || "");
  }, [searchParams]);

  const sendEmail = () => {
    const mailto =
      "mailto:info@pferdeosteopathie-laskowski.de" +
      "?subject=" + encodeURIComponent(betreff) +
      "&body=" + encodeURIComponent(nachricht);
    window.location.href = mailto;
  };

  return (
    <Form>
      <TextField
        className="kontakt-formular-margin-top kontakt-formular-bg-light-green"
        variant="filled"
        label="Betreff"
        fullWidth
        required
        value={betreff}
        onChange={(e) => setBetreff(e.target.value)}
      />
      <TextField
        className="kontakt-formular-margin-top kontakt-formular-bg-light-green"
        variant="filled"
        label="Nachricht"
        fullWidth
        required
        multiline
        minRows={5}
        value={nachricht}
        onChange={(e) => setNachricht(e.target.value)}
      />
      <p
        className="kontakt-formular-margin-top"
        style={{ fontSize: "0.85rem", lineHeight: 1.4, margin: "16px 0 0" }}
      >
        Mit Klick auf &bdquo;Anfrage per E-Mail senden&ldquo; werden Betreff
        und Nachricht an Ihr lokales E-Mail-Programm &uuml;bergeben, das den
        Versand &uuml;bernimmt. Auf dieser Website werden keine Daten erhoben
        oder gespeichert. Weitere
        Informationen in der{" "}
        <Link to="/datenschutzerklaerung" style={{ color: "inherit", textDecoration: "underline" }}>
          Datenschutzerkl&auml;rung
        </Link>
        .
      </p>
      <Button
        className="kontakt-formular-margin-top"
        sx={{ textTransform: "none" }}
        variant="contained"
        fullWidth
        disabled={betreff === "" || nachricht === ""}
        onClick={sendEmail}
      >
        Anfrage per E-Mail senden
      </Button>
    </Form>
  );
}
